import {
  BaseFullSchema_OLD,
  BaseRefSchema,
  BaseCreateSchema,
  BaseUpdateSchema,
  PaginatedResponse,
  WorldLocation,
} from "./common/commonTypes";
import { AddressType } from "./common/termTypes";

export interface AddressFull extends BaseFullSchema_OLD {
  name: string;
  addressee?: string;
  attn?: string;
  line_1: string;
  line_2?: string;
  line_3?: string;
  city: string;
  city_obj: WorldLocation<"city">;
  state: string;
  state_obj: WorldLocation<"state">;
  country: string;
  country_obj: WorldLocation<"country">;
  zip: string;
  phone?: string;
  email?: string;
  notes: string | null;
  is_preferred: boolean;
  address_type: AddressType;
  entity_id: string;
  entity_table: string;
}

export interface AddressRef extends BaseRefSchema {
  name: string;
  line_1: string;
  city: string;
  city_obj: WorldLocation<"city">;
  state: string;
  state_obj: WorldLocation<"state">;
  country: string;
  country_obj: WorldLocation<"country">;
  zip: string;
  is_preferred: boolean;
  address_type: AddressType;
  entity_id: string;
  entity_table: string;
}

export interface AddressCreate extends BaseCreateSchema {
  name: string;
  addressee: string | null;
  attn: string | null;
  line_1: string;
  line_2: string | null;
  line_3: string | null;
  city: string;
  city_obj: WorldLocation<"city">;
  state: string;
  state_obj: WorldLocation<"state">;
  country: string;
  country_obj: WorldLocation<"country">;
  zip: string;
  phone: string | null;
  email: string | null;
  notes: string | null;
  is_preferred: boolean;
  address_type: AddressType;
  entity_id: string | null;
  entity_table: string | null;
}

export interface AddressUpdate extends BaseUpdateSchema {
  name?: string;
  addressee?: string | null;
  attn?: string | null;
  line_1?: string;
  line_2?: string | null;
  line_3?: string | null;
  city?: string;
  city_obj?: WorldLocation<"city">;
  state?: string;
  state_obj?: WorldLocation<"state">;
  country?: string;
  country_obj?: WorldLocation<"country">;
  zip?: string;
  phone?: string | null;
  email?: string | null;
  notes?: string | null;
  is_preferred?: boolean;
  address_type?: AddressType;
}

export type PaginatedAddressResponse = PaginatedResponse<AddressFull>;

export interface OrderAddressEdit {
  addressee: string | null;
  attn: string | null;
  line_1: string | null;
  line_2: string | null;
  line_3: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  zip: string | null;
  phone: string | null;
  email: string | null;
}

export type OrderAddressEditKey = keyof OrderAddressEdit;

export const OrderAddressEditDefaults: OrderAddressEdit = {
  addressee: null,
  attn: null,
  line_1: null,
  line_2: null,
  line_3: null,
  city: null,
  state: null,
  country: null,
  zip: null,
  phone: null,
  email: null,
};

export interface WorldCountrySchema {
  id: number;
  name: string;
  iso3: string;
  iso2: string;
  phonecode: string;
  currency: string;
  emoji: string;
}

export interface WorldCountryCreate {
  name: string;
  iso3: string;
  iso2: string;
  phonecode: string;
  currency: string;
  emoji: string;
}

export interface WorldStateSchema {
  id: number;
  country_id: number;
  name: string;
  iso2: string;
  iso3166_2: string;
}

export interface WorldStateCreate {
  country_id: number;
  name: string;
  iso2: string;
  iso3166_2: string;
}

export interface WorldCitySchema {
  id: number;
  state_id: number;
  country_id: number;
  name: string;
}

export interface WorldCityCreate {
  state_id: number;
  country_id: number;
  name: string;
}

export interface WorldLocationResponse {
  countries: WorldCountrySchema[];
  states: WorldStateSchema[];
  cities: WorldCitySchema[];
}
